<template>
    <v-card>
        <v-container>
            <v-card-title>{{ $t('passwordLost.title') }}</v-card-title>
            <v-card-text v-if="blocked">
                <v-alert dense outlined type="error">
                    {{ blockedMessage }}
                </v-alert>
            </v-card-text>
            <v-card-text v-else>
                <div class="choose">
                    <v-radio-group v-model="choose">
                        <v-radio
                            id="resetPasswordEmail"
                            :label="$t('passwordLost.home.mail')"
                            value="mail"
                            color="#3200E6"
                        ></v-radio>
                        <v-radio
                            data-cy="resetPasswordLogin"
                            :label="$t('passwordLost.home.login')"
                            value="id"
                            color="#3200E6"
                        ></v-radio>
                    </v-radio-group>
                </div>
                <v-form @submit.prevent v-if="choose === 'mail'">
                    <v-text-field
                        color="#3200E6"
                        v-model="choose_mail"
                        :label="$t('passwordLost.home.mail')"
                        type="mail"
                        data-cy="resetPasswordEmailText"
                    ></v-text-field>
                </v-form>
                <v-form @submit.prevent v-if="choose === 'id'">
                    <v-text-field
                        data-cy="resetPasswordIdText"
                        color="#3200E6"
                        v-model="choose_id"
                        :label="$t('passwordLost.home.login')"
                    ></v-text-field>
                </v-form>
                <div class="actions">
                    <v-btn
                        data-cy="resetPasswordConfirm"
                        :disabled="!isValid || submitted"
                        :loading="submitted"
                        class="action"
                        @click="submit"
                    >
                        {{ $t('passwordLost.next') }}
                    </v-btn>
                </div>
            </v-card-text>
        </v-container>
    </v-card>
</template>

<script>
import { api } from '@utils/api';
import axios from 'axios';

export default {
    data() {
        return {
            choose: 'mail',
            choose_mail: null,
            choose_id: null,
            blocked: false,
            blockedMessage: null,
            submitted: false
        };
    },
    methods: {
        async submit() {
            this.submitted = true;
            const data = {};
            if (this.choose === 'mail') {
                data.geodisMail = this.choose_mail;
            } else if (this.choose === 'id') {
                data.geodisLogin = this.choose_id;
            }
            const anonymous = await api.get('anonymous', null, null, 'admin');
            if (anonymous.message === 'anonymous succeed') {
                const ret = await api.post('passwordLost', data, null, 'admin');
                let attemptStatus = {};
                if (ret && ret.message === 'Found') {
                    data.userInformations = await api.post('userInfo', data, null, 'accMgmt');

                    // Check attempt status from backend before proceeding
                    try {
                        const response = await axios.post(`${window.location.origin}/api/v1/passaccount/sq/attempt-status`, data, {
                            withCredentials: true
                        });
                        attemptStatus = response.data;
                        if (attemptStatus && attemptStatus.blocked) {
                            this.blocked = true;
                            const msg = attemptStatus.errorMessage;
                            this.blockedMessage =
                                (msg && msg[this.$i18n.locale]) || (msg && msg.en) || this.$t('passwordLost.questions.error');
                            return;
                        }
                    } catch (error) {
                        // If attempt-status returns 400/404 with blocked info, check it
                        const errorData = error.response?.data;
                        if (errorData && errorData.blocked) {
                            this.blocked = true;
                            this.blockedMessage = this.$t('passwordLost.questions.error');
                            return;
                        }
                        console.warn('Could not check attempt status:', error);
                    }

                    data.sqUser = await api.post('sqUser', { geodisLogin: data.userInformations.geodisLogin }, null, 'accMgmt');
                    this.$session.start();
                    this.$session.set('passwordlost-data', btoa(unescape(encodeURIComponent(JSON.stringify(data)))));
                    this.$session.set('attempt-status', btoa(unescape(encodeURIComponent(JSON.stringify(attemptStatus)))));
                    this.$router.push('/password-lost/secret-questions');
                }
            }
            this.submitted = false;
        }
    },
    computed: {
        isValid: function () {
            return this.choose_mail || this.choose_id;
        }
    },
    watch: {
        choose(to, from) {
            if (to === 'mail') {
                this.choose_id = null;
            } else {
                this.choose_mail = null;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.v-text-field {
    width: 400px;
}

.actions {
    margin-top: 20px;
}
</style>
